export const shouldRenderLocationWarning = (senderLocation, newLocationId, locations) => {
  if (newLocationId) {
    const newLocation = locations.find(location => location.id === newLocationId)
    if (newLocation) {
      return senderLocation?.address?.country?.region_id !== newLocation?.address?.country?.region_id
    }
  }

  return false
}
